import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import styles from "./styles.module.scss";
import clsx from "clsx";

const Timeline = ({ timelineContent }) => (
  <VerticalTimeline layout="1-column-left" lineColor="#E5E7EB">
    {timelineContent.map((item, index) => {
      const isFirstElement = index === 0;

      return (
        <VerticalTimelineElement
          key={item?.statusName}
          date={item.date}
          dateClassName={clsx(
            styles.date,
            isFirstElement ? styles.dateActive : "",
          )}
          iconStyle={
            isFirstElement
              ? { background: "#FFBE2E" }
              : { background: "#C4C4C4" }
          }
          position="left"
          iconClassName={styles.verticalTimelineIcon}
          className={styles.verticalTimelineElementContainer}
          contentStyle={{
            boxShadow: "none",
            display: "flex",
            flexDirection: "column-reverse",
            alignItems: "flex-start",
            padding: "0",
          }}
        >
          <p className={styles.paragraph}>{item.paragraph}</p>
          <h3
            className={clsx(
              "vertical-timeline-element-title",
              !isFirstElement ? styles.heading : "",
            )}
          >
            {item.statusRUName || item.statusName || '-'}
          </h3>
        </VerticalTimelineElement>
      );
    })}
  </VerticalTimeline>
);

export default Timeline;
